import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/geracaoAutomatica/';

class GeracaoAutomaticaService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAll(idCliente, ano, mes) {
        return axios.get(API_URL + 'all?idCliente='+idCliente+'&ano='+ano+'&mes='+mes, {headers: this.headers});
    }

    obterVencimento(idCliente, idConta, competencia) {
        return axios.get(API_URL + 'obterVencimento?idCliente='+idCliente+'&idConta='+idConta+'&competencia='+competencia, {headers: this.headers});
    }
    
    gerarDeclaracoes(idCliente, idUsuario, ano, mes, declaracoes) {
        return axios.post(API_URL + 'gerarDeclaracoes?idCliente='+idCliente+'&idUsuario='+idUsuario+'&ano='+ano+'&mes='+mes, JSON.stringify(declaracoes), {headers: this.headers});
    }

    reprocessarDeclaracoes(idCliente, idUsuario, idDeclaracao) {
        return axios.post(API_URL + 'reprocessarDeclaracoes?idCliente='+idCliente+'&idUsuario='+idUsuario+'&idDeclaracao='+idDeclaracao, null, {headers: this.headers});
    }

    findAllDeclaracoes(idCliente) {
        return axios.get(API_URL + 'allDeclaracoes?idCliente='+idCliente, {headers: this.headers});
    }

    findAllDeclaracoesEmAndamento(idCliente) {
        return axios.get(API_URL + 'allDeclaracoesEmAndamento?idCliente='+idCliente, {headers: this.headers});
    }
}

export default new GeracaoAutomaticaService();